(function () {
  function stripTitles(root) {
    (root || document).querySelectorAll('.header__inline-menu a.gm-target[title]')
      .forEach(a => a.removeAttribute('title'));
  }

  function init() {
    const nav = document.querySelector('.header__inline-menu');
    stripTitles();                 // clean whatever's already there
    if (!nav) return;

    // Re-clean whenever Globo injects/re-renders the menu or re-adds a title
    const observer = new MutationObserver(() => stripTitles(nav));
    observer.observe(nav, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['title']
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();